/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContractTypeGroupEnumDTO } from './contract-type-group-enum-dto';


/**
 * Defines a contract type group change. Validation: * `fccDataCenterContractTypeGroup` has to be filled if `fccDataCenterEnabled` is true * If `contractTypeGroup` or `fccDataCenterContractTypeGroup` is type `V` then both have to be `V` * If `fccDataCenterEnabled` is false (FCC Data Center is disabled for the contract) then these fields cannot be set:   * `fccDataCenterContractTypeGroup`   * `contractedFccDataCenterErs` 
 */
export interface ContractChangeLogDTO { 
    /**
     * Month, since when the change takes effect.
     */
    from: string;
    contractTypeGroup: ContractTypeGroupEnumDTO;
    /**
     * Unique project number associated with the contract. Used for billing purposes.
     */
    projectNumber: string;
    /**
     * Volume of defined signatures per month per each business premises. Only for the contract type group V (volume).
     */
    volume?: number;
    /**
     * Number of contracted business premises to calculate the pool. Only for the contract type group V (volume).
     */
    contractedBusinessPremises?: number;
    /**
     * The max number of business premises to add for this contract. Only for the contract type group V (volume).
     */
    businessPremisesLimit?: number;
    /**
     * Number of contracted ERSes connected to cloud TSS FCC to calculate the pool. Only for the contract type group S, A, G.
     */
    contractedCloudErs?: number;
    /**
     * Number of contracted ERSes connected to hardware TSS FCC to calculate the pool. Only for the contract type group S, A, G.
     */
    contractedTokenErs?: number;
    /**
     * Flag indicating whether FCC data center is supported in the fiscal contract or not.
     */
    fccDataCenterEnabled?: boolean;
    fccDataCenterContractTypeGroup?: ContractTypeGroupEnumDTO;
    /**
     * Number of contracted ERSes connected to FCC Data Center.
     */
    contractedFccDataCenterErs?: number;
    /**
     * Volume of defined signatures per month per each business premises with FCC Data Center. Only for the contract type group V (volume).
     */
    fccDataCenterVolume?: number;
    /**
     * Number of contracted business premises with FCC Data Center to calculate the pool. Only for the contract type group V (volume).
     */
    fccDataCenterContractedBusinessPremises?: number;
}

export class ClsContractChangeLogDTO { 
    /**
     * Month, since when the change takes effect.
     */
    from: string = undefined;
    contractTypeGroup: ContractTypeGroupEnumDTO = undefined;
    /**
     * Unique project number associated with the contract. Used for billing purposes.
     */
    projectNumber: string = undefined;
    /**
     * Volume of defined signatures per month per each business premises. Only for the contract type group V (volume).
     */
    volume?: number = undefined;
    /**
     * Number of contracted business premises to calculate the pool. Only for the contract type group V (volume).
     */
    contractedBusinessPremises?: number = undefined;
    /**
     * The max number of business premises to add for this contract. Only for the contract type group V (volume).
     */
    businessPremisesLimit?: number = undefined;
    /**
     * Number of contracted ERSes connected to cloud TSS FCC to calculate the pool. Only for the contract type group S, A, G.
     */
    contractedCloudErs?: number = undefined;
    /**
     * Number of contracted ERSes connected to hardware TSS FCC to calculate the pool. Only for the contract type group S, A, G.
     */
    contractedTokenErs?: number = undefined;
    /**
     * Flag indicating whether FCC data center is supported in the fiscal contract or not.
     */
    fccDataCenterEnabled?: boolean = undefined;
    fccDataCenterContractTypeGroup?: ContractTypeGroupEnumDTO = undefined;
    /**
     * Number of contracted ERSes connected to FCC Data Center.
     */
    contractedFccDataCenterErs?: number = undefined;
    /**
     * Volume of defined signatures per month per each business premises with FCC Data Center. Only for the contract type group V (volume).
     */
    fccDataCenterVolume?: number = undefined;
    /**
     * Number of contracted business premises with FCC Data Center to calculate the pool. Only for the contract type group V (volume).
     */
    fccDataCenterContractedBusinessPremises?: number = undefined;
}



